var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBodhijourneyIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "157F5209-243F-432B-90D3-D38B6F0B1356") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company-info",
    transform: "translate(-129.000000, -472.000000)",
    fill: "#00142D"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(129.000000, 472.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-838",
    transform: "translate(13.659975, 13.660093) rotate(-330.000000) translate(-13.659975, -13.660093) translate(3.660297, 3.660093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3451901,0.148855459 C17.04611,-0.319446675 15.6145387,0.353841802 15.1470698,1.65458847 C14.7270978,2.81867759 15.2295643,4.08442659 16.2744947,4.67272073 L14.1904669,10.462335 C13.4513494,10.3298438 12.7130653,10.5406631 12.1564357,11.002299 L10.051576,9.19741928 C10.7365303,8.05749522 10.4148851,6.57176087 9.29579297,5.83097689 C8.14420303,5.06852769 6.59180645,5.38517326 5.83019053,6.53676321 C5.11523816,7.61752453 5.36022184,9.04409616 6.3459895,9.8465427 L3.34618936,15.1553557 C2.21876447,14.7470495 0.93218352,15.1928532 0.323890713,16.2711147 C-0.355230708,17.4727013 0.0680744234,18.9967664 1.27132759,19.6758878 C2.4729142,20.3558425 3.99781261,19.9308708 4.67776731,18.7292842 C5.28606012,17.6501895 5.00274566,16.3186115 4.07280761,15.5653284 L7.06927464,10.2623483 C7.90338574,10.5623283 8.82999067,10.3923397 9.50744554,9.82904386 L11.6073056,11.6297572 C10.7873603,13.0021658 11.4364837,14.7403833 12.9030526,15.2686815 C14.2012995,15.7361503 15.6337041,15.0628618 16.1011729,13.7637817 C16.5211449,12.598026 16.0186784,11.3331103 14.973748,10.7448162 L17.0577758,4.95520191 C18.236864,5.16768775 19.4309511,4.51273139 19.8509231,3.347809 C20.3183919,2.0478956 19.6451035,0.617157592 18.3451901,0.148855459",
    id: "Fill-2861"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBodhijourneyIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bodhijourney_icon.03776f81aeee4065e751ec9275799d4a.svg";